import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNumberCircleThree = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 19,
	viewBox: "0 0 16 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8 15.5322C11.3137 15.5322 14 12.8459 14 9.53223C14 6.21852 11.3137 3.53223 8 3.53223C4.68629 3.53223 2 6.21852 2 9.53223C2 12.8459 4.68629 15.5322 8 15.5322Z",
		stroke: "currentColor",
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.5 6.78223H9.5L7.75 9.28223C8.03778 9.28225 8.32111 9.35324 8.57491 9.48891C8.8287 9.62458 9.04511 9.82075 9.20499 10.06C9.36486 10.2993 9.46325 10.5743 9.49145 10.8607C9.51965 11.1471 9.47679 11.4361 9.36666 11.7019C9.25652 11.9678 9.08252 12.2024 8.86007 12.385C8.63761 12.5676 8.37357 12.6924 8.09132 12.7486C7.80907 12.8047 7.51733 12.7904 7.24194 12.7069C6.96654 12.6234 6.716 12.4732 6.5125 12.2697",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgNumberCircleThree;
